import apiHeader from '@/helpers/apiHeader';

const costCenterService = {
  list(page, params) {
    return apiHeader.get('cost-centers?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('cost-centers/' + id);
  },
};

export default costCenterService;
